<template>
    <div class="form__location">
        <div
            v-show="type === 'automatic'"
            class="form__location_automatic"
        >
            <label
                for="form-location-address"
                class="form__text_title"
            >{{ $t('forms.location.title.address') }}<span v-if="required" class="asterisk">*</span></label>
            <div class="form__location_automatic_fields">
                <input
                    ref="autocomplete"
                    type="text"
                    class="form form__location_automatic_fields_search hidden"
                    placeholder="Type to find address"
                    id="form-location-address"
                    :disabled="disabled"
                />
                <input
                    type="text"
                    :id="name | toKebabCase"
                    :class="['form', 'form__location_automatic_fields_placeholder', valueFormatted !== '' ? 'valid' : '']"
                    name="location-automatic-placeholder"
                    autocomplete="off"
                    ref="placeholder"
                    v-validate="required ? (type === 'automatic' ? 'required' : '') : ''"
                    :value="valueFormatted"
                    :data-vv-as="dataVvAs ? dataVvAs : name"
                    :disabled="disabled"
                    @click="switchAutocomplete"
                    @blur="blurAutocomplete"
                >
                <span
                    class="form__error form__location_error"
                    v-if="valueFormatted === ''"
                >{{ errors.first('location-automatic-placeholder') }}</span>
            </div>
        </div>
        <div
            v-if="type === 'manual'"
            class="form__location_manual"
        >
            <form-text
                :label="$t('forms.location.labels.address1')"
                :name="'address-1'"
                :required="true"
                :v-validate="'required'"
                :value="valueAddress1"
                :disabled="disabled"
                :data-vv-as="'address 1'"
                @input="$emit('emit-update-value-address1')"
            />
            <form-text
                :label="$t('forms.location.labels.address2')"
                :name="'address-2'"
                :value="valueAddress2"
                :disabled="disabled"
                :data-vv-as="'address 2'"
                @input="$emit('emit-update-value-address2')"
            />
            <form-text
                :label="$t('forms.location.labels.townCity')"
                :name="'city'"
                :required="true"
                :value="valueCity"
                :v-validate="'required'"
                :disabled="disabled"
                :data-vv-as="'city'"
                @input="$emit('emit-update-value-city')"
            />
            <form-text
                :label="$t('forms.location.labels.county')"
                :name="'county'"
                :required="true"
                :value="valueCounty"
                :v-validate="'required'"
                :disabled="disabled"
                :data-vv-as="'county'"
                @input="$emit('emit-update-value-county')"
            />
            <form-text
                :label="$t('forms.location.labels.postCode')"
                :name="'postcode'"
                :required="true"
                :value="valuePostcode"
                :v-validate="{ required: true, regex: /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/ }"
                :disabled="disabled"
                :data-vv-as="'postcode'"
                @input="$emit('emit-update-value-postcode')"
            />
            <form-select
                :items="countries"
                :label="$t('forms.location.labels.country')"
                :name="'country'"
                :required="true"
                :value="valueCountry"
                :v-validate="'required'"
                :disabled="disabled"
                :data-vv-as="'country'"
                @input="emitCountryChange"
            />
        </div>
        <component-button
            v-if="!disabled"
            :size="'tiny'"
            :name="'form-notification-switch-button'"
            :text="true"
            @click="switchType"
        >{{ type === 'manual' ? $t('forms.location.buttons.toggle') : $t('forms.location.buttons.enter') }}</component-button>
    </div>
</template>

<script>
import { loadedGoogleMapsAPI } from '@/loadedGoogleMaps'
import FormText from '@/components/default/forms/FormText'
import FormSelect from '@/components/default/forms/FormSelect'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  components: {
    ComponentButton,
    FormSelect,
    FormText
  },
  name: 'form-location',
  data () {
    return {
      address: {},
      autocomplete: '',
      countries: [
        { label: 'Albania', value: 'Albania' },
        { label: 'Andorra', value: 'Andorra' },
        { label: 'Austria', value: 'Austria' },
        { label: 'Belarus', value: 'Belarus' },
        { label: 'Belgium', value: 'Belgium' },
        { label: 'Bosnia and Herzegovina', value: 'Bosnia and Herzegovina' },
        { label: 'Bulgaria', value: 'Bulgaria' },
        { label: 'Croatia', value: 'Croatia' },
        { label: 'Cyprus', value: 'Cyprus' },
        { label: 'Czech Republic', value: 'Czech Republic' },
        { label: 'Denmark', value: 'Denmark' },
        { label: 'Estonia', value: 'Estonia' },
        { label: 'Faroe Islands', value: 'Faroe Islands' },
        { label: 'Finland', value: 'Finland' },
        { label: 'France', value: 'France' },
        { label: 'Germany', value: 'Germany' },
        { label: 'Gibraltar', value: 'Gibraltar' },
        { label: 'Greece', value: 'Greece' },
        { label: 'Hungary', value: 'Hungary' },
        { label: 'Iceland', value: 'Iceland' },
        { label: 'Ireland', value: 'Ireland' },
        { label: 'Isle of Man', value: 'Isle of Man' },
        { label: 'Italy', value: 'Italy' },
        { label: 'Kosovo', value: 'Kosovo' },
        { label: 'Latvia', value: 'Latvia' },
        { label: 'Liechtenstein', value: 'Liechtenstein' },
        { label: 'Lithuania', value: 'Lithuania' },
        { label: 'Luxembourg', value: 'Luxembourg' },
        { label: 'Macedonia', value: 'Macedonia' },
        { label: 'Malta', value: 'Malta' },
        { label: 'Moldova', value: 'Moldova' },
        { label: 'Monaco', value: 'Monaco' },
        { label: 'Montenegro', value: 'Montenegro' },
        { label: 'Netherlands', value: 'Netherlands' },
        { label: 'Norway', value: 'Norway' },
        { label: this.$t('forms.location.translatedLanguages.poland'), value: 'Poland' },
        { label: 'Portugal', value: 'Portugal' },
        { label: 'Romania', value: 'Romania' },
        { label: 'Russia', value: 'Russia' },
        { label: 'San Marino', value: 'San Marino' },
        { label: 'Serbia', value: 'Serbia' },
        { label: 'Slovakia', value: 'Slovakia' },
        { label: 'Slovenia', value: 'Slovenia' },
        { label: 'Spain', value: 'Spain' },
        { label: 'Sweden', value: 'Sweden' },
        { label: 'Switzerland', value: 'Switzerland' },
        { label: 'Ukraine', value: 'Ukraine' },
        { label: 'United Kingdom', value: 'United Kingdom' },
        { label: 'Vatican city', value: 'Vatican city' },
        { label: 'Yugoslavia', value: 'Yugoslavia' }
      ]
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: true
    },
    valueAddress1: {
      type: String,
      default: ''
    },
    valueAddress2: {
      type: String,
      default: ''
    },
    valueCounty: {
      type: String,
      default: ''
    },
    valuePostcode: {
      type: String,
      default: ''
    },
    valueCity: {
      type: String,
      default: ''
    },
    valueCountry: {
      type: String,
      default: ''
    },
    valueType: {
      type: String,
      default: ''
    },
    valueFormatted: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean
    },
    dataVvAs: {
      type: String,
      default: ''
    }
  },
  computed: {
    type: function () {
      return this.valueType
    },
    automaticValidate: function () {
      return this.type === 'automatic' ? 'required' : ''
    }
  },
  mounted () {
    const self = this

    loadedGoogleMapsAPI.then(() => {
      this.initMap()
    })

    this.$refs.autocomplete.onfocus = function () {
      self.$refs.placeholder.classList.add('hidden')
      self.$refs.autocomplete.classList.remove('hidden')
    }
    this.$refs.autocomplete.onblur = function () {
      self.$refs.placeholder.classList.remove('hidden')
      self.$refs.autocomplete.classList.add('hidden')
    }
  },
  methods: {
    initMap: function () {
      const options = {
        componentRestrictions: { country: 'gb' }
      }
      const google = window.google
      this.autocomplete = new google.maps.places.Autocomplete((this.$refs.autocomplete), options)

      this.autocomplete.addListener('place_changed', () => {
        let place = this.autocomplete.getPlace()
        let ac = place.address_components
        let lat = place.geometry.location.lat()
        let lon = place.geometry.location.lng()
        let fa = place.formatted_address

        let data = {}

        for (let i = 0; i < ac.length; i++) {
          let type = ac[i].types[0]
          let value = ac[i].long_name
          data[type] = value
        }

        data['lat'] = lat
        data['lng'] = lon
        data['formatted_address'] = fa

        this.address = data
        this.emitChange(data)
      })
    },
    switchType: function () {
      this.$emit('emit-type', this.type === 'automatic' ? 'manual' : 'automatic')
    },
    switchAutocomplete: function () {
      this.$validator.pause()
      this.$validator.reset()
      this.$refs.autocomplete.focus()
    },
    blurAutocomplete () {
      this.$validator.resume()
      this.$validator.reset()
      this.$emit('emit-blur')
    },
    //
    resetLocation: function () {
      this.$validator.reset()
      this.$refs.autocomplete.value = ''
    },
    //
    emitCountryChange: function (value) {
      this.$emit('emit-update-value-country', value ? value.value : '')
    },
    emitChange: function (data) {
      this.$emit('emit-change', data)
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formlocation";
</style>
